<template>
    <a-row class="content-panle margin-0 padding-tb-0" :gutter="24">
      <a-col :span="12" class="padding-tb-md">
        <h3 class="panle-head" style="margin-bottom:16px">
         预约基本信息扩展字段设置
        </h3>
      </a-col>
      <a-col :lg="24" :sm="24" :xl="24" :xxl="18">
        <k-form-design
          title=""
          ref="kfd"
          :fields="config.fields"
          showToolbarsText
          :toolbars="config.toolbars"
          style="height: 575px"
          :hideModel="true"
        />
      </a-col>
      <a-col :lg="24" :sm="24" :xl="24" :xxl="18" style="padding: 10px 15px 30px 15px;text-align: right">
        <a-button type="primary" html-type="submit" :loading="fieldConfirmLoading" @click="handlerSubmit">
          {{ $t('userCenter.submitMiniProgSetBtn') }}
        </a-button>
      </a-col>
    </a-row>
</template>

<script>
import { getUserConfig, setUserConfig } from '@/api/userMana'
import { enumToTemplate, templateToEnum } from './components/enums'
import template from './components/template.json'

export default {
  name: 'extFieldsSettings',
  components: {
  },
  data() {
    return {
      fieldConfirmLoading: false,
      config:{
        fields:[
          'input',
          'textarea',
          'number',
          'select',
          'checkbox',
          'switch',
          'radio',
          'time',
          'date',
        ],
        toolbars:[
          'reset'
        ],
      },


    }
  },
  computed: {},
  mounted() {
    // console.log("进入组件")
    this.getSettings()
  },
  deactivated() {
    // this.form.resetFields()
  },
  methods: {
    // 获取设置
    async getSettings() {
      let _this = this
      try {
        const res = await getUserConfig()
        const {
          appointmentApplyCustomExFieldConfig
        } = res.data.collection[0]
        _this.settings = res.data.collection[0]
        //扩展字段设置
        if (appointmentApplyCustomExFieldConfig) {
          let data = JSON.parse(appointmentApplyCustomExFieldConfig) || null
          this.dataConversion(data)
        }
      } catch (error) {
      }
    },

    handleFormFieldsEdit(data) {
      this.fieldConfirmLoading = true
      setUserConfig({
        key: 'appointmentApplyCustomExFieldConfig',
        value: JSON.stringify(data)
      }).then(() => {
        setTimeout(()=>{
          this.$notification.success({
            message: '扩展字段设置成功',
            description: ''
          })
          this.getSettings()
          this.fieldConfirmLoading = false
        },1500)
      }).catch((err)=>{
        console.log(err)
        setTimeout(()=>{
          this.$notification.error({
            message: err,
            description: ''
          })
          this.fieldConfirmLoading = false
        },1500)
      })

    },

    handlerSubmit() {
      let formJson = this.$refs.kfd.getValue()
      if (formJson && formJson.list) {
        let widgetList = formJson.list
        if (widgetList.length > 10) {
          this.$message.error('仅能配置10个字段，请谨慎使用')
          return
        }
        // 字段转换
        let data = []
        widgetList.forEach((item, index) => {
          // console.log(item)
          let type = templateToEnum[item.type === 'date' && item.options.showTime ? 'datetime' : item.type]
          let param = {
            'defaultValue': item.options.defaultValue,
            'id': item.key,
            'name': item.label,
            'order': index,
            'type': type,
            'valid': {
              'allowEmpty': !item.rules[0].required,
            }
          }
          if (item.type === 'number') {
            let dv = 0
            let precision = item.options.precision===null? 0 :item.options.precision
            param['defaultValue'] = dv.toFixed(precision)
            param['valid'] = {
              'allowEmpty': !item.rules[0].required,
              'max': item.options.max,
              'min': item.options.min,
              'precision': item.options.precision
            }
          }
          if (item.type === 'input' || item.type === 'textarea') {
            param['valid'] = {
              'allowEmpty': !item.rules[0].required,
              'maxLength': item.options.maxLength || 255,
              'isTextArea': item.type === 'textarea',
            }
          }
          //默认值保存为int类型
          if (item.type === 'radio' || item.type === 'checkbox' || item.type === 'select') {
            let optionItems = item.options.options
            let items = []
            optionItems.forEach((i, idx) => {
              items.push({
                code: parseInt(i.value),
                name: i.label,
                order: idx
              })
            })
            param['enums'] = items
            if (item.type === 'checkbox') {
              param['defaultValue'] = (!item.options.defaultValue || item.options.defaultValue.length === 0 ) ? null: item.options.defaultValue
            }
            if (item.type === 'radio') {
              param['defaultValue'] = !item.options.defaultValue  ? null: item.options.defaultValue
            }
          }
          data.push(param)
        })
        this.handleFormFieldsEdit( data)
      }
    },
    // 生成设备标组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.confirmLoading = false
      this.$refs.vfDesigner.clearDesigner()
    },

    dataConversion(data) {
      // console.log(data)
      let params = []
      for (let i = 0; i < data.length; i++) {
        let item = data[i]
        let fieldType = enumToTemplate[item.type]
        if (item.type === 1 && item.valid.isTextArea){
          fieldType = 'textarea'
        }
        // console.log('fieldType:',fieldType)
        // 需要深度拷贝
        let temp = JSON.parse(JSON.stringify(template[fieldType]))
        temp.model = item.id
        temp.key = item.id
        temp.label = item.name
        temp.options.defaultValue = item.defaultValue
        temp.rules[0].required = !item.valid.allowEmpty
        if (fieldType === 'number') {
          temp.options.max = item.valid.max
          temp.options.min = item.valid.min
          temp.options.precision = item.valid.precision
        }
        if (fieldType === 'input' || fieldType === 'textarea') {
          temp.options.maxLength = item.valid.maxLength
        }
        //默认值为int
        if (fieldType === 'radio' || fieldType === 'checkbox' || fieldType === 'select') {
          let enums = item.enums
          enums = enums.sort(function (a, b) {
            return a.order - b.order; // 返回负值表示交换位置
          });

          let ops = []
          for (let i = 0; i < enums.length; i++) {
            let o = {
              label: enums[i].name,
              value: enums[i].code
            }
            ops.push(o)
          }
          temp.options.options = ops
          if ( fieldType === 'checkbox' ){
            // console.log(item.defaultValue )
            temp.options.defaultValue = !item.defaultValue ? [] : item.defaultValue
          }
        }
        params.push(temp)
      }
      // console.log(params)
      let importTemplate = {
        "list": params,
        "config": {
          "layout": "horizontal",
          "labelCol": {
            "xs": 4,
            "sm": 4,
            "md": 4,
            "lg": 4,
            "xl": 4,
            "xxl": 4
          },
          "labelWidth": 100,
          "labelLayout": "flex",
          "wrapperCol": {
            "xs": 18,
            "sm": 18,
            "md": 18,
            "lg": 18,
            "xl": 18,
            "xxl": 18
          },
          "hideRequiredMark": false,
          "customStyle": ""
        }
      }
      this.$refs.kfd.handleSetData(importTemplate)
      // _this.$refs.vfDesigner.setFormJson(template)
      // _this.$refs.vfDesigner.designer.loadFormJson(importTemplate)
      //
      // _this.$refs.vfDesigner.designer.emitHistoryChange()
      // _this.$refs.vfDesigner.designer.emitEvent('form-json-imported', [])

    }

  }
}
</script>

<style scoped>
.upload-image-tip {
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 5px;
  color: rgba(0, 0, 0, 0.45);
}
</style>
